



































import { Component, Mixins, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { ObjectUtility } from "../../../../utilities";
import { IConfiguration } from "../../../../domain/configuration";

@Component({
  components: {
  }
})
export default class SystemSettingSystemEditor extends Mixins() {
  data(): any {
    return {
      defaultConfiguration: null as string,
      currentConfiguration: null as string,
      mergedConfiguration: null as string,
    };
  }
  defaultConfiguration: string;
  currentConfiguration: string;
  mergedConfiguration: string;

  mounted(): any {
    this.refresh();
  }

  async refresh(): Promise<void> {
    this.refreshDefaultConfiguration();
    await this.refreshCurrentConfiguration();
  }

  refreshDefaultConfiguration(): void {
    const repository = DomainRegistry.developer.getConfigurationRepository();
    const defaultConfiguration = repository.getDefaultConfiguration();
    this.defaultConfiguration = JSON.stringify(defaultConfiguration, null , "  ");
  }

  async refreshCurrentConfiguration(): Promise<void> {
    const repository = DomainRegistry.developer.getConfigurationRepository();
    const currentConfiguration = await repository.getSystemConfiguration();
    this.currentConfiguration = JSON.stringify(currentConfiguration, null , "  ");
  }

  @Watch("currentConfiguration")
  updateMergedConfiguration(): void {
    try {
      const mergedConfiguration = ObjectUtility.mergeDeeply(JSON.parse(this.defaultConfiguration), JSON.parse(this.currentConfiguration));
      this.mergedConfiguration = JSON.stringify(mergedConfiguration, null , "  ");
    } catch (e) {
      console.error(e);
      this.mergedConfiguration = e.toString();
    }
  }

  async save(): Promise<void> {
    try {
      if (!this.currentConfiguration) { return; }
      const configuration = JSON.parse(this.currentConfiguration) as IConfiguration;
      if (!configuration) {
        this.$warn("設定保存", "設定が空です。");
        return;
      }

      const index = await this.$commonDialogs.confirmation.confirmSaveCancel(
        null,
        ["システム設定を保存してもよろしいですか？"]
      );
      if (index !== 0) { return; }
      const repository = DomainRegistry.developer.getConfigurationRepository();
      repository.registerSystemConfiguration(configuration)
      .then(() => {
        this.$success("設定保存", "設定の保存に成功しました。");
        this.refresh();
      })
      .catch(e => {
        this.$error("設定保存", "設定の保存に失敗しました。", e);
      });
    } catch (e) {
      this.$error("設定保存", "設定の保存に失敗しました。", e);
    }
  }
}
